import { useState } from "react";
import { api, formatError, wasteLabel } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ShieldCheck, Check, X, Loader2 } from "lucide-react";

export default function VerifyBarcodeDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true); setRes(null);
    try {
      const { data } = await api.get(`/barcodes/lookup/${code}`);
      setRes({ ok: true, data });
    } catch (err) {
      setRes({ ok: false, msg: formatError(err) });
    } finally { setBusy(false); }
  };

  const reset = () => { setCode(""); setRes(null); };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) reset(); }}>
      <DialogTrigger asChild>
        {trigger || <Button variant="outline" className="rounded-full gap-2" data-testid="verify-open"><ShieldCheck className="w-4 h-4" /> Verifica barcode</Button>}
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Verifica codice a barre</DialogTitle></DialogHeader>
        <form onSubmit={verify} className="space-y-3">
          <div>
            <Label className="text-xs uppercase tracking-wider text-gray-600">Codice (8 cifre)</Label>
            <Input
              inputMode="numeric" maxLength={8}
              value={code}
              onChange={(e) => { setCode(e.target.value.replace(/\D/g, "")); setRes(null); }}
              placeholder="00000000"
              className="mt-1.5 font-mono text-xl tracking-widest text-center"
              data-testid="op-verify-input"
            />
          </div>
          <Button type="submit" disabled={busy || code.length !== 8} className="w-full rounded-full h-11" data-testid="op-verify-submit">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Verifica
          </Button>
        </form>

        {res && (
          <div className={`mt-2 p-4 rounded-lg border text-sm ${
            res.ok ? "bg-emerald-50 border-emerald-200 text-emerald-900" : "bg-red-50 border-red-200 text-red-900"
          }`} data-testid="op-verify-result">
            {res.ok ? (
              <>
                <div className="flex items-center gap-2 font-semibold"><Check className="w-4 h-4" /> Codice valido</div>
                <div className="mt-2 space-y-1 text-xs">
                  <div>Seriale: <span className="font-mono">{String(res.data.serial).padStart(6, "0")}</span></div>
                  <div>Checksum: <span className="font-mono">{res.data.check_code}</span></div>
                  <div>Assegnato a: <span className="font-medium">utente {res.data.user_id?.slice(0, 8)}</span></div>
                  <div>Stato: {res.data.is_used ? <span className="font-semibold text-amber-700">Già utilizzato</span> : <span className="font-semibold text-emerald-700">Disponibile</span>}</div>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-2"><X className="w-4 h-4" /> {res.msg}</div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
